import {combineReducers} from '@modifi/redux'
import entityReducer from './entity'
import updateReducer from './update'

export default combineReducers({
  entity: entityReducer,
  update: updateReducer,
})
